import React__default from 'react';
import { c as classNames, be as MOBILE_BREAKPOINT, ai as createClassName } from './className-0524835a.js';
import { u as useElementWidth, a as SkeletonContainer, S as Skeleton } from './SkeletonContainer-fd90b3af.js';

const TableSkeleton = ({ hasActions, hasRole }) => {
    const { ref, width } = useElementWidth();
    const classes = classNames(className(), {
        [className('hasActions')]: hasActions
    });
    return React__default.createElement(SkeletonContainer, { className: classes, hasRole: hasRole },
        React__default.createElement("div", { ref: ref }, width > MOBILE_BREAKPOINT
            ? React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: className('row') },
                    React__default.createElement(Skeleton, { width: 80, height: 24 }),
                    React__default.createElement(Skeleton, { width: 80, height: 24 }),
                    React__default.createElement(Skeleton, { width: 80, height: 24 }),
                    hasActions && React__default.createElement("div", null)),
                React__default.createElement(RowSkeleton, { widths: ['55%', '45%', '60%'], hasActions: hasActions }),
                React__default.createElement(RowSkeleton, { widths: ['45%', '35%', '85%'], hasActions: hasActions }),
                React__default.createElement(RowSkeleton, { widths: ['70%', '55%', '45%'], hasActions: hasActions }))
            : React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: className('row') },
                    React__default.createElement(Skeleton, { width: 120, height: 24 })),
                React__default.createElement(MobileRowSkeleton, { widths: ['50%', '70%'], hasActions: hasActions }),
                React__default.createElement(MobileRowSkeleton, { widths: ['40%', '60%'], hasActions: hasActions }),
                React__default.createElement(MobileRowSkeleton, { widths: ['75%', '30%'], hasActions: hasActions }))));
};
const RowSkeleton = ({ widths, hasActions }) => {
    return React__default.createElement("div", { className: className('row') },
        React__default.createElement(Skeleton, { width: widths[0] }),
        React__default.createElement(Skeleton, { width: widths[1] }),
        React__default.createElement(Skeleton, { width: widths[2] }),
        hasActions && React__default.createElement("div", { className: className('actions') },
            React__default.createElement(Skeleton, { variant: "circular", height: 20, width: 20 }),
            React__default.createElement(Skeleton, { variant: "circular", height: 20, width: 20 })));
};
const MobileRowSkeleton = ({ widths, hasActions }) => {
    return React__default.createElement("div", { className: className('mobileRow') },
        React__default.createElement("div", null,
            React__default.createElement(Skeleton, { width: widths[0], height: 24 }),
            React__default.createElement(Skeleton, { width: widths[1], height: 24 })),
        hasActions && React__default.createElement("div", { className: className('actions') },
            React__default.createElement(Skeleton, { variant: "circular", height: 25, width: 25 }),
            React__default.createElement(Skeleton, { variant: "circular", height: 25, width: 25 })));
};
const className = createClassName('TableSkeleton');

export { TableSkeleton as T };
